<template>
   <div class="drugInfo">
     <Search :title="name" :conclusion="conclusion">
       <div class="explain box-body">
         <p><span>适用范围：</span>{{ system }}</p>
         <p><span>通用名：</span>{{ comname }}</p>
         <p><span>商用名：</span>{{ goodsname }}</p>
       </div>

       <div class="test_result">
         <p class="test_result_title">检测结果</p>
         <div class="test_result_title_result">
           <p class="test_result_message">{{ conclusion }}</p>
         </div>
       </div>

       <div class="box">
         <van-tabs v-model="activeTab">
           <van-tab title="关注基因">
             <GeneList isshow="drug" :data="gene_list" :note="note"></GeneList>
           </van-tab>
           <van-tab title="参考文献">
             <div v-if="gdb3">
               <Paper :data="documents" :fake="fake_gene" :single="single"></Paper>
             </div>
             <div v-if="gdb2">
               <div class="paper">
                 <p class="paper-item">本报告中的用药建议严格遵守最新的药物基因组学知识库以及临床药物基因组学实施联盟（CPIC）等权威机构提供的国际指南。</p>
                 <p class="paper-item">参考："Pharmacogenomics Knowledge for Personalized Medicine" Clinical Pharmacology & Therapeutics(2012) 92(4): 414-417.</p>
                 <p class="paper-item">声明：检测结果仅供医生参考，不作为临床诊断依据</p>
               </div>
             </div>
           </van-tab>
         </van-tabs>
       </div>

       <div class="disease-content">
         <ExpandableText icon="iconshiyirenqun" color="red" title="适应症" :text="desc"></ExpandableText>
         <ExpandableText icon="iconyao" color="purple" title="药理毒理作用" :text="toxic"></ExpandableText>
         <ExpandableText icon="iconbuliang" color="orange" title="不良反应/毒副作用" :text="reactions"></ExpandableText>
         <ExpandableText icon="iconmutual" color="green" title="药物相互作用" :text="interaction"></ExpandableText>
       </div>

       <div v-if="gdb3">
         <Pagination url="drugInfo" :id="id"></Pagination>
       </div>
     </Search>
   </div>
</template>

<script>
import Search from '@/components/Search'
import ExpandableText from '@/components/ExpandableText'
import GeneList from '@/components/GeneList'
import Paper from '@/components/Paper'
import Pagination from '@/components/Pagination'
export default {
  name: 'drugInfo',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      activeTab: 0,
      id: this.$route.params.id,
      name: '', // 药物名称
      system: '', // 药物系统分类(适用范围)
      comname: '', // 药物通用名称
      goodsname: '', // 药物商品名称
      drug_age: '', // 年龄
      conclusion: '', // 药物结论
      gene_list: [], // 基因列表(关注基因)
      documents: [], // 参考文献
      single: '', // XY同源染色体判断结果
      fake_gene: '', // 假基因
      desc: '', // 药物介绍(适应症)
      toxic: '', // 病理/毒理作用
      reactions: '', // 药物不良反应
      interaction: '', // 药物相互作用
      note: '' // 药物备注
    }
  },
  methods: {
    getDrugDetails () {
      this.util.get(this.api.drug_details + '?id=' + this.id, '', (success) => {
        this.name = success.details.name
        this.system = success.details.system
        this.comname = success.details.comname
        this.goodsname = success.details.goodsname
        this.drug_age = success.details.drug_age
        this.conclusion = success.details.conclusion
        this.gene_list = success.details.gene_list
        this.documents = success.details.documents
        if (success.details.fake_gene) {
          this.fake_gene = success.details.fake_gene
        }
        if (success.details.single) {
          this.single = success.details.single
        }
        this.desc = success.details.desc
        this.toxic = success.details.toxic
        this.reactions = success.details.reactions
        this.interaction = success.details.interaction
        this.note = success.details.note
      })
    },
    // gdb2
    getDrugDetails1 () {
      this.util.get1(this.api.drugDetails + '?itemid=' + this.id, '', (success) => {
        this.name = success.chanme
        this.system = success.system
        this.comname = success.comname
        this.goodsname = success.goodsname
        this.conclusion = success.conclusion
        this.gene_list = success.gene
        this.desc = success.drug_desc
        this.toxic = success.drug_toxic
        this.reactions = success.drug_reaction
        this.interaction = success.drug_interaction
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getDrugDetails()
    } else {
      this.gdb2 = true
      this.getDrugDetails1()
    }
  },
  watch: {
    '$route' (to) {
      this.id = parseInt(to.params.id)
      this.getDrugDetails()
    }
  },
  components: {
    Search,
    ExpandableText,
    GeneList,
    Paper,
    Pagination
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .drugInfo {
    .explain {
      background-color: #fff;

      p {
        margin: pxToRem(10px) 0;

        span {
          font-weight: 500;
        }
      }
    }
    .paper {
      color: #000;
      padding: pxToRem(30px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/drug/drugInfo.vue